import React from "react";
import "./styles.css";

const CloseIcon = ({ isActive, handleClick }) => {
  return (
    <div className="icon-container icon-margin-right" id="invite">
      <a className="icon-anchor" onClick={handleClick}>
        <svg
          className="svg-container element-icon"
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlSpace="preserve"
          xmlnsserif="http://www.serif.com/"
        >
          <g transform="matrix(1.79021,0,0,1.79021,53.7063,19.6923)">
            <circle className={`el-circle-close ${isActive ? "active" : ""}`} cx="113" cy="132" r="143" />
          </g>
          <g transform="matrix(14.2273,0,0,14.2273,85.2727,78.1591)">
            <path
              className="el-path-close"
              d="M1.454,11.589C2.393,10.377 4.014,9.24 5.854,8.409C7.709,7.572 9.885,7 12,7C14.115,7 16.291,7.572 18.146,8.409C19.986,9.24 21.607,10.377 22.546,11.589C23.296,12.556 23.011,13.773 22.455,14.515L20.386,17.276C19.858,17.982 18.924,18.202 18.155,17.802L14.612,15.963C14.066,15.68 13.77,15.052 13.89,14.43L14.105,13.312C13.556,13.198 12.808,13.091 12,13.091C11.192,13.091 10.444,13.198 9.894,13.312L10.11,14.43C10.23,15.052 9.934,15.68 9.388,15.963L5.846,17.802C5.076,18.202 4.142,17.982 3.614,17.276L1.545,14.515C0.989,13.773 0.704,12.556 1.454,11.589ZM12,11.217C13.406,11.217 14.649,11.489 15.259,11.674C15.816,11.842 16.118,12.42 16.012,12.968L15.728,14.447L18.962,16.126L21.031,13.364C21.134,13.227 21.183,13.084 21.192,12.974C21.2,12.875 21.178,12.813 21.14,12.764C20.45,11.874 19.117,10.891 17.426,10.128C15.751,9.371 13.82,8.874 12,8.874C10.18,8.874 8.249,9.371 6.574,10.128C4.883,10.891 3.55,11.874 2.861,12.764C2.822,12.813 2.8,12.875 2.808,12.974C2.817,13.084 2.866,13.227 2.97,13.364L5.038,16.126L8.272,14.447L7.988,12.968C7.882,12.42 8.184,11.842 8.741,11.674C9.351,11.489 10.594,11.217 12,11.217Z"
            />
          </g>
        </svg>
        {!isActive && (
          <div className="tooltip-btm">
            <p>Close session</p>
            <div className="triangle-btm"></div>
          </div>
        )}
      </a>
    </div>
  );
};
export default CloseIcon;
